import axios from 'axios';
import { Building2 } from 'lucide-react';
import { categories, WHATSAPP_NUMBER } from '../../data/constants';

export const API = process.env.REACT_APP_BACKEND_URL || '';
export const RAZORPAY_LINK = 'https://rzp.io/rzp/IAsHdUN';
export const SUPPORT_WA = '447831230648';
export const SERVICES_WA = WHATSAPP_NUMBER;
export const PREMIUM_AMOUNT = 99;
export const TERMS_VERSION = 'smartqr-v1-2026-06';

// Smart QR category list = existing JustOffs categories + Real Estate (Smart QR only; deals categories untouched)
export const SMART_QR_CATEGORIES = [
  ...categories,
  { id: 'real-estate', name: 'Real Estate', short: 'Realty', icon: Building2, color: 'bg-emerald-600', placeholder: '' },
];
export const smartCatName = (id) => SMART_QR_CATEGORIES.find((c) => c.id === id)?.name || id;

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(`${API}/api/upload/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  return res.data.url;
};

export const waLink = (number, text) => `https://wa.me/${number || ''}?text=${encodeURIComponent(text)}`;

export const copyText = async (text) => {
  try {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(text); return true; }
  } catch { /* fall through to legacy copy */ }
  const ta = document.createElement('textarea');
  ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
  document.body.appendChild(ta); ta.select();
  let ok = false;
  try { ok = document.execCommand('copy'); } catch { ok = false; }
  ta.remove();
  return ok;
};

export const mgmtShareMsg = (businessName, url) => `Your JustOffs Smart Business QR management link for ${businessName}:\n${url}\nUse this private link to update your business page and products anytime. Your QR code stays the same. Do not share it publicly.`;

export const imgSrc = (url) => (url && url.startsWith('/') ? `${API}${url}` : url);

export const downloadFile = async (url, filename) => {
  const res = await fetch(imgSrc(url));
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
};

export const inputCls = 'w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white';
export const labelCls = 'block text-xs font-semibold text-slate-600 mb-1';
